import React from 'react';
import styled, { keyframes } from 'styled-components';
import Color from 'color';
import { Check } from './Check';

const longFadeIn = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const StyledSurveySubmittedContainer = styled.div`
  animation: ${longFadeIn} 0.6s ease-in 1;
  margin-top: 1rem;
  max-width: 15rem;
  width: 90%;
  background: ${({ theme }) => Color(theme.ob_colors.info).alpha(0.25).string()};
  display: flex;
  padding: 0.5rem 0;
`;

const CheckContainer = styled.div`
  padding: 0 0.5rem;
  svg {
    path {
      fill: ${({ theme }) => theme.ob_colors.primary};
    }
  }
`;

const SurveyText = styled.div`
  font-size: 14px;
`;

export const SurveySubmitted = ({ surveyText }) => {
  return (
    <StyledSurveySubmittedContainer key={surveyText}>
      <CheckContainer>
        <Check />
      </CheckContainer>
      <SurveyText>{surveyText}</SurveyText>
    </StyledSurveySubmittedContainer>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/SurveySubmitted.tsx